import { render, staticRenderFns } from "./UpdateUserLog.vue?vue&type=template&id=6628cda9&lang=pug&"
import script from "./UpdateUserLog.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports